import PropTypes from 'prop-types'
import { fixActionText } from 'features/editlog/editlogUtils'
import HelpTooltip from 'components/tooltip/HelpTooltip'
import TimeTableReadOnly from 'features/editlog/layers/TimeTableReadOnly'
import TrackerName from 'features/editlog/TrackerName'
import { toBit } from '../../../components/TimeTable'
import { useSelector } from 'react-redux'

const { REACT_APP_BIZ_WALLET_HOST } = process.env

const BeforeAfterSummary = ({ type, value, summary }) => {
  if (type === 'ADGROUP_IMPRESSION_WEEKLY_SCHEDULE_CHANGE') {
    return <TimeTableReadOnly weeklySchedule={toBit(value)} size="small" />
  } else if (type === 'CAMPAIGN_CONVERSION_TRACKING_CHANGE') {
    return <TrackerName id={value} />
  } else if (
    type === 'ADACCOUNT_BIZ_WALLET_CREATE' ||
    type === 'ADACCOUNT_BIZ_WALLET_CHANGE' ||
    type === 'ADACCOUNT_BIZ_WALLET_DELETE'
  ) {
    return (
      <a
        href={`${REACT_APP_BIZ_WALLET_HOST}/detail/${value}`}
        className="txt_limit fc_emph">
        {summary}
      </a>
    )
  } else {
    return summary
  }
}
BeforeAfterSummary.propTypes = {
  type: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array,
  ]),
  summary: PropTypes.string,
}

const BeforeAfterActionRow = ({
  type,
  actionSummary,
  before,
  beforeSummary,
  after,
  afterSummary,
}) => (
  <tr>
    <th scope="row">{fixActionText(actionSummary)}</th>
    <td>
      <div
        className="inner_cell"
        style={{
          ...(type === 'ADGROUP_IMPRESSION_WEEKLY_SCHEDULE_CHANGE' && {
            maxHeight: 'none',
          }),
        }}>
        <BeforeAfterSummary
          type={type}
          value={before}
          summary={beforeSummary}
        />
      </div>
    </td>
    <td>
      <div
        className="inner_cell"
        style={{
          ...(type === 'ADGROUP_IMPRESSION_WEEKLY_SCHEDULE_CHANGE' && {
            maxHeight: 'none',
          }),
        }}>
        <BeforeAfterSummary type={type} value={after} summary={afterSummary} />
      </div>
    </td>
  </tr>
)
BeforeAfterActionRow.propTypes = {
  type: PropTypes.string,
  actionSummary: PropTypes.string,
  before: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array,
  ]),
  beforeSummary: PropTypes.string,
  after: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array,
  ]),
  afterSummary: PropTypes.string,
}
const DetailHasBeforeAfter = () => {
  const {
    historyDto: { actions = [] },
  } = useSelector(state => state.editlog.selectedDetail)
  return (
    <>
      <p className="subtit_layer">
        내용
        <HelpTooltip>일부 항목은 내용의 이력을 제공하지 않습니다.</HelpTooltip>
      </p>
      <table className="tbl_layer tbl_layer_cont">
        <caption className="hide_caption">변경이력 내용 안내 표</caption>
        <colgroup>
          <col style={{ width: 161 }} />
          <col />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="col">구분</th>
            <th scope="col">변경전</th>
            <th scope="col">변경후</th>
          </tr>
          {actions?.map((action, index) => (
            <BeforeAfterActionRow key={index} {...action} />
          ))}
        </tbody>
      </table>
    </>
  )
}

export default DetailHasBeforeAfter
